import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { getUserRole } from "utils/storage";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" >
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>
            <li>
              <Link to="/organizers" >
                <i className="bx bx-user-pin"></i>
                <span>{props.t("Organizers")}</span>
              </Link>
            </li>
            <li>
              <Link to="/venues">
              <i className="bx bx-buildings"></i>
              <span>{props.t("Venues")}</span>
              </Link>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-calendar"></i>
                <span>{props.t("Events")}</span>
              </Link>
              <ul className="sub-menu">

                <li>
                  <Link to="/admin/events">{props.t("Event List")}</Link>
                </li>

                {/* <li>
                  <Link to="/event/new">{props.t("Create New")}</Link>
                </li> */}
                <li>
                  <Link to="/event-venue">{props.t("Event Venue")}</Link>
                </li>
                <li>
                  <Link to="/event/newquick">{props.t("Create Quick Event")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-calendar"></i>
                <span>{props.t("Public Events List")}</span>
              </Link>
              <ul className="sub-menu">
              <li>
                  <Link to="/create-list-event">{props.t("Create List Event")}</Link>
                </li>
                <li>
                  <Link to="/list-event">{props.t(" List Events")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-coupon"></i>
                <span>{props.t("Tickets")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/event-ticket">{props.t("Event Tickets")}</Link>
                </li>
                <li>
                  <Link to="/ticket-group">{props.t("Ticket Groups")}</Link>
                </li>
                <li>
                  <Link to="/booking-slot">{props.t("Slot Bookings")}</Link>
                </li>
                <li>
                  <Link to="/free-ticket">{props.t('Free Bookings')}</Link>
                </li>
                {getUserRole() === 1 && (
                <li>
                  <Link to="/spot-booking">{props.t("Spot Bookings")}</Link>
                </li>
                )}
              </ul>
            </li>

            {/* <li>
              <Link to="bookings" >
                <i className="bx bxs-detail"></i>
                <span>{props.t("Bookings")}</span>
              </Link>
            </li>
            <li className="menu-title">{props.t("Accounts")} </li>
            <li>
              <Link to="/profile" >
                <i className="bx bx-user-circle"></i>
                <span>{props.t("Profile")}</span>
              </Link>
            </li>
            <li>
              <Link to="#" >
                <i className="bx bx-cog"></i>
                <span>{props.t("Change Password")}</span>
              </Link>
            </li> */}
            <li>
              <Link to="/discover-management" >
                <i className="mdi mdi-compass-outline"></i>
                <span>{props.t("Discover")}</span>
              </Link>
            </li>
            <li>
              <Link to="/forum" >
                <i className="bx bxs-detail"></i>
                <span>{props.t("Forum")}</span>
              </Link>
            </li>
            <li>
              <Link to="/coupons" >
                <i className="bx bx-tag"></i>
                <span>{props.t("Coupons")}</span>
              </Link>
            </li>
            {/* <li>
              <Link to="/booking" >
                <i className="bx bx-receipt"></i>
                <span>{props.t("Booking")}</span>
              </Link>
            </li> */}
            <li>
              <Link to="/reports" >
                <i className="bx bxs-report"></i>
                <span>{props.t("Reports")}</span>
              </Link>
            </li>
            <li>
              <Link to="/contact-list" >
                <i className="bx bxs-user-detail"></i>
                <span>{props.t("Contacts")}</span>
              </Link>
            </li>
            <li>
              <Link to="/sponsor-list" >
                <i className="bx bx-group"></i>
                <span>{props.t("Sponsors")}</span>
              </Link>
            </li>
            <li>
              <Link to="/artist-management">
                <i className="bx bx-music"></i>
                <span>{props.t("Artist Management")}</span>
              </Link>
            </li>
            <li>
              <Link to="/inquires">
                <i className="bx bx-message-square-detail"></i>
                <span>{props.t("Inquire")}</span>
              </Link>
            </li>
            <li>
              <Link to="/public-venue-list">
                <i className="bx bx-building-house"></i>
                <span>{props.t("Public Venue List")}</span>
              </Link>
            </li>
            {getUserRole() === 1 && (
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-group"></i>
                <span>{props.t("Users")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/country-admin">{props.t("Country Admin")}</Link>
                </li>
                <li>
                  <Link to="/new-user">{props.t("Venue Users")}</Link>
                </li>
              </ul>
            </li>
            )}
            <li>
              <Link to="/sub-user" >
                <i className="bx bxs-detail"></i>
                <span>{props.t("Add Subuser")}</span>
              </Link>
            </li>
            {getUserRole() === 1 && (
            <li>
            <Link to="/#" className="has-arrow">
              <i className="bx bx-group"></i>
              <span>{props.t("Entitlements")}</span>
            </Link>

            <ul className="sub-menu">
              <li>
                <Link to="/manage-entitlements">
                  {props.t("Manage Entitlements")}
                </Link>
              </li>

              <li>
                <Link to="/organizer-entitlements">
                  {props.t("Organizer Entitlements")}
                </Link>
              </li>
            </ul>
          </li>
          )}
            {getUserRole() === 1 && (
              <li>
                <Link to="/refund">
                  <i className="bx bx-transfer"></i>
                  {props.t("Refund")}
                </Link>
              </li>
            )}
            <li>
              <Link to="/ManagePassword" >
                <i className="bx bxs-lock"></i>
                <span>{props.t("Change Password")}</span>
              </Link>
            </li>
            <li>
              <Link to="/logout" >
                <i className="bx bx-exit"></i>
                <span>{props.t("Logout")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));